import { Type } from '@angular/core';
import { AllergyIcon } from './icons/allergy-icon';
import { EaseLogoIcon } from './icons/ease-logo-icon';
import { EaseWordmarkIcon } from './icons/ease-wordmark-icon';
import { StarFilledIcon } from './icons/star-filled-icon';

/**
 * Registry for custom (designer-provided) icons.
 * Add custom icon components here as they are delivered.
 *
 * Usage:
 * 1. Create a component for the custom icon SVG
 * 2. Register it here with a unique name
 * 3. Use it with: <ease-icon name="custom-name" source="ease" />
 */
export const EASE_ICON_REGISTRY: Record<string, Type<unknown>> = {
  allergy: AllergyIcon,
  'ease-logo': EaseLogoIcon,
  'ease-wordmark': EaseWordmarkIcon,
  'star-filled': StarFilledIcon,
};
